import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { dimensionUnits } from "@redotech/redo-fulfillment-measurements-common/dimension-conversion";
import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const consolidationCartonLabelParcelSchema = z.object({
  height: z.number().positive(),
  length: z.number().positive(),
  dimensionUnit: z.enum(dimensionUnits),
  weight: WeightSchema.extend({ value: z.number().positive() }),
  width: z.number().positive(),
});
export type ConsolidationCartonLabelParcel = z.infer<
  typeof consolidationCartonLabelParcelSchema
>;

export const consolidationCartonLabelAddressSelectionSchema =
  z.discriminatedUnion("kind", [
    z.object({
      kind: z.literal("location"),
      locationId: locationIdFormat.schema,
    }),
    z.object({
      kind: z.literal("returnsCenter"),
      returnsCenterId: returnsCenterIdFormat.schema,
    }),
    z.object({
      address: FulfillmentOrderAddressSchema,
      kind: z.literal("address"),
    }),
  ]);
export type ConsolidationCartonLabelAddressSelection = z.infer<
  typeof consolidationCartonLabelAddressSelectionSchema
>;

export const consolidationCartonLabelDraftSchema = z.object({
  destination: consolidationCartonLabelAddressSelectionSchema,
  origin: consolidationCartonLabelAddressSelectionSchema,
  parcel: consolidationCartonLabelParcelSchema,
});
export type ConsolidationCartonLabelDraft = z.infer<
  typeof consolidationCartonLabelDraftSchema
>;

export const consolidationCartonPurchasedLabelSchema = z.object({
  labelUrl: z.string(),
  redoShipmentId: z.string(),
  trackingNumber: z.string(),
});
export type ConsolidationCartonPurchasedLabel = z.infer<
  typeof consolidationCartonPurchasedLabelSchema
>;
